import $ from 'jquery'
import manager from '../manager'
import { INTERFACE,SLD } from '@/utils/INTERFACE'
import {isApp} from '@/utils/page'
import url from 'url'
import querystring from 'querystring'
import Cookies from 'js-cookie'
import * as compareVersions from 'compare-versions'

function checkVersion(){
	let current=Cookies.get("cv")
	return compareVersions(current, '4.1.0')>=0
}

manager.add('appLink',function(){
	if(!isApp())return
	$(this.dom).find('[href*="//"]').each(function(){ 
		var str=this.href
		var skuMatch=str.match(/\/\/m\.(jd\.ru|joybuy\.com|joybuy\.es)\/(\d+)\.html/i)
		if(skuMatch&&skuMatch[2]){
			this.href=INTERFACE().item.app(skuMatch[2])
			return
		}
		var indexMatch=str.match(/\/\/m\.(jd\.ru|joybuy\.com|joybuy\.es)\/?$/i)
		if(indexMatch){
			this.href=INTERFACE().index.app
			return 
		}
		var listMatch=str.match(/\/\/mall\.(jd\.ru|joybuy\.com|joybuy\.es)\/m\/list-(\d+)\.html\?shopCategoryId=(\d+)/i)
		if(listMatch&&listMatch[3]){
			this.href=INTERFACE().mall.list.app(null,listMatch[3])
			return 
		}
		if(str.match(/\/\/m\.(jd\.ru|joybuy\.com|joybuy\.es)\/search.result\/list/i)){
			try{
				let query=querystring.parse(url.parse(str).query)
				var params=encodeURIComponent(JSON.stringify({
					des:'search',
					params:{
						keyword:query.keywords,
						categoryId:query.categoryId,
						categoryName:query.title
					}
				}))
				this.href=`${SLD().appProto}?params=${params}`
			}catch(err){
				//
			}
			return
		}
		if(str.match(/\/\/esale\.jd\.com\/zgb\/m/i)){
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			if(isAndroid||checkVersion()){
				this.href =INTERFACE().sale.app(this.href)
			}
			return
		}
		if(str.match(/\/\/.*\/m\/.*/)){
			this.href = this.href.replace(/\/m\//, '/app/');
			return
		}
	})
})